/**
 * 获取权限
 * @param {*} model  当前模块 
 * @param {*} this_  VUE 
 * 
 * 接口获取当前用户的当前模块权限,并将获取到的权限
 */
export async function getAuthorityByModel(model, this_) {
    try {
        let requestData = {
            userId: '1',
            model: model
        }
        let data = await this_.$request({
            url: "/authority/getAuthorityByModel",
            method: "post",
            data: requestData,
        });
        localStorage.setItem(model, JSON.stringify(data))
    } catch (error) {
        this.$message.error(error.message);
    }
}